<template>
	<div class="no-tasks-message" data-testid="no-task-message">
		<CCallout v-if="showTaskSetupInfo" class="no-tasks-message__callout" type="info" :use-icon="false" data-testid="no-task-callout" title="Start Using Workflow Tasks">
			<div>Allow users to view and complete their assigned tasks at each step in your workflow.</div>
			<template #button>
				<a href="/support/466/workflow/workflow-tasks" class="button button--primary flex--no-shrink" target="_blank">Learn More</a>
			</template>
		</CCallout>
		<div class="no-tasks-message__content">
			<strong class="block">{{ resources.NoTasks }}</strong>
			<Inline svg="complex-icons/tenacious" class="text-primary" />
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent, inject } from 'vue';
	import CCallout from 'src/components/content/Callout.vue';
	import { localizationResourcesKey } from 'src/utilities/injection-keys';

	export default defineComponent({
		name: 'CNoTasksMessage',
		components: {
			CCallout
		},
		props: {
			showTaskSetupInfo: {
				type: Boolean,
				default: false
			}
		},
		setup() {
			const resources = inject(localizationResourcesKey);

			return {
				resources
			};
		}
	});
</script>

<style lang="scss">
.no-tasks-message {

	&__callout {
		// max-width to make banner match existing dashboard banners
		max-width: 1500px;
		margin-bottom: var(--spacing-4);

		.form-picker & {
			flex-wrap: wrap;
			margin: $space__4;
			margin-bottom: 0;
		}

		@include b-down($b12) {

			.no-forms & {
				margin: 0 $space__5;
			}
		}

		@include b-down($b9) {

			.no-forms & {
				margin: 0 $space__4;
			}
		}

		@include b-down($b7) {
			flex-wrap: wrap;
		}
	}

	&__content {
		padding-top: $space__4;
		padding-bottom: $space__4;
		text-align: center;

		.i-tenacious {
			width: 200px;
			max-width: 90%;

			.i-fill {
				fill: var(--shade-4);
			}
		}

		.no-forms & {
			background: var(--shade-2);

			p {
				font-size: $size__4;
			}
		}
	}

	.callout__content {
		container-type: inline-size;
	}

	.callout__button-container {
		@container (max-width: 250px) {
			flex-wrap: wrap;
		}
	}
}
</style>